<template>
  <div class="album-backup">
    <!-- 首屏 banner -->
    <div class="section-banner">
      <div class="banner-main">
        <div class="banner-left">
          <div class="banner-title move">相册备份</div>
          <div class="banner-subtitle move delay-100"">无损备份相册到任意远程设备</div>
          <div class="banner-desc move delay-200">
            iPhone/Android手机可将原始照片与视频，自动备份到已绑定的设备中，无需依赖公有云，让你的私有相册存储与管理更轻松。原片无损备份、自动同步、释放手机空间、数据自主可控。
          </div>
          <div class="banner-btns">
            <div class="btn-primary" @click="goDownload">立即体验</div>
            <div class="btn-ghost" @click="goDoc">查看文档</div>
          </div>
        </div>
        <img class="banner-pic" :src="bannerPic" alt="" />
      </div>
      <div class="banner-features-wrap">
        <div class="banner-features">
          <div class="feature-item">
            <img class="feature-icon" :src="featPhoto" alt="" />
            <div class="feature-text">
              <div class="feature-title">照片无损</div>
              <div class="feature-sub">保留原始画质与内容</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featAuto" alt="" />
            <div class="feature-text">
              <div class="feature-title">增量备份</div>
              <div class="feature-sub">备份增量照片/视频</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featPrivate" alt="" />
            <div class="feature-text">
              <div class="feature-title">私有存储</div>
              <div class="feature-sub">数据存放在自己的设备</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心能力 -->
    <div class="section-adv">
      <div class="adv-main">
        <div class="section-title move">核心优势</div>
        <div class="section-sub move delay-100">轻松管理多节点网络</div>
        <div class="adv-grid">
          <div class="adv-card move" v-for="(item, index) in advList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <img class="adv-icon" :src="item.icon" alt="" />
            <div class="adv-title">{{ item.title }}</div>
            <div class="adv-desc" v-html="item.desc"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工作原理 -->
    <div class="section-flow">
      <div class="flow-main">
        <div class="section-title move">工作原理</div>
        <div class="section-sub move delay-100">极致简单，安全访问</div>
        <div class="flow-grid">
          <template v-for="(item, index) in flowList">
            <div class="flow-card move" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
              <div class="flow-top">
                <img :src="item.img" alt="" />
              </div>
              <div class="flow-title">{{ item.title }}</div>
              <div class="flow-desc">{{ item.desc }}</div>
            </div>
            <div v-if="index < flowList.length - 1" class="flow-arrow" :key="'arrow-' + index">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M8 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 使用方式（深色区） -->
    <div class="section-usage">
      <div class="usage-main">
        <div class="section-title move">使用方式</div>
        <div class="usage-grid">
          <div class="usage-card move" v-for="(item, index) in usageList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <div class="usage-top">
              <img :src="item.img" alt="" />
            </div>
            <div class="usage-title">{{ item.title }}</div>
            <div class="usage-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="section-scene">
      <div class="scene-main">
        <div class="section-title move">应用场景</div>
        <div class="scene-grid">
          <div class="scene-card move" v-for="(item, index) in sceneList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <div class="scene-img-wrap">
              <img :src="item.img" alt="" />
            </div>
            <div class="scene-title">{{ item.title }}</div>
            <div class="scene-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="section-cta">
      <img class="cta-overlay" :src="ctaOverlay" alt="" />
      <div class="cta-main">
        <div class="cta-title">开启你的相册备份体验</div>
        <div class="cta-sub">将iOS/Android照片备份到Windows、macOS、NAS、Docker 设备，安全存储，轻松管理。</div>
        <div class="btn-primary cta-btn" @click="goDownload">免费体验</div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/components/Foot.vue'

export default {
  name: 'AlbumBackup',
  components: {
    Foot,
  },
  data: function () {
    return {
      bannerPic: require('@/assets/album/banner_pic.webp'),
      featPhoto: require('@/assets/album/feat_photo.png'),
      featAuto: require('@/assets/album/feat_auto.png'),
      featPrivate: require('@/assets/album/feat_private.png'),
      ctaOverlay: require('@/assets/album/cta_bg.png'),
      advList: [
        {
          icon: require('@/assets/album/ic_origin.png'),
          title: '原片无损备份',
          desc: '保留原始画质与视频内容',
        },
        {
          icon: require('@/assets/album/ic_auto.png'),
          title: '自动同步',
          desc: '新照片自动上传，省心省力',
        },
        {
          icon: require('@/assets/album/ic_private.png'),
          title: '私有存储',
          desc: '数据存放在自己的私有设备，更加安全可控',
        },
        {
          icon: require('@/assets/album/ic_space.png'),
          title: '空间释放',
          desc: '手机照片备份到NAS或电脑，释放手机空间',
        },
        {
          icon: require('@/assets/album/ic_safe.png'),
          title: '安全可控',
          desc: '传输安全，权限可控，数据更安心',
        },
      ],
      // 工作原理 3 步：绑定设备 → 设置备份位置 → 一键备份
      flowList: [
        {
          img: require('@/assets/album/flow_bind.png'),
          title: '绑定设备',
          desc: '电脑/NAS安装节点小宝',
        },
        {
          img: require('@/assets/album/flow_target.png'),
          title: '设置备份位置',
          desc: '选择作为相册存储的设备与目录',
        },
        {
          img: require('@/assets/album/flow_upload.png'),
          title: '一键备份',
          desc: '一键备份手机相册/视频至电脑或NAS',
        },
      ],
      usageList: [
        {
          img: require('@/assets/album/usage_auto.png'),
          title: '一键相册备份',
          desc: '开机节点小宝无需繁琐设置，一键备份整机相册',
        },
        {
          img: require('@/assets/album/usage_multi.png'),
          title: '多设备集中存储',
          desc: '家庭成员或多台手机的照片与视频统一存储同一设备',
        },
        {
          img: require('@/assets/album/usage_category.png'),
          title: '分类查看与管理',
          desc: '按时间、设备或目录整理照片与视频素材',
        },
      ],
      sceneList: [
        {
          img: require('@/assets/album/scene_family.webp'),
          title: '家庭照片长期保存',
          desc: '重要回忆集中留存，不怕误删',
        },
        {
          img: require('@/assets/album/scene_kids.webp'),
          title: '孩子成长记录',
          desc: '时刻保留孩子成长的照片与视频，留下美好瞬间',
        },
        {
          img: require('@/assets/album/scene_travel.webp'),
          title: '旅行素材归档',
          desc: '出行拍摄内容自动回传到家中设备',
        },
        {
          img: require('@/assets/album/scene_work.webp'),
          title: '工作现场照片留存',
          desc: '工程、巡检、门店、现场拍摄资料统一保存',
        },
      ],
    }
  },
  methods: {
    goDownload: function () {
      if (this.$route.path !== '/download') {
        this.$router.push('/download')
      }
    },
    goDoc: function () {
      window.open('https://iepose.com/helpcenter_v3/')
    },
    // 滚动检查：进入视口的 .move 元素加 move-active，触发入场动画（同首页模式）
    checkInView: function (animatedElements) {
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight
      animatedElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        const elementBottom = element.getBoundingClientRect().bottom
        const isInView = elementTop < windowHeight - 100 && elementBottom > 0
        if (isInView) {
          element.classList.add('move-active')
        }
      })
    },
  },
  mounted: function () {
    const animatedElements = document.querySelectorAll('.move')
    // 首屏元素立即检查一次（页面刚加载时尚未触发 scroll，避免首屏内容空白）
    this.$nextTick(() => {
      this.checkInView(animatedElements)
    })
    window.addEventListener('scroll', () => {
      this.checkInView(animatedElements)
    })
  },
}
</script>

<style scoped lang="less">
.album-backup {
  width: 100%;

  .section-title {
    font-size: 40px;
    font-weight: 700;
    color: #1d1f24;
    text-align: center;
  }

  .section-sub {
    margin-top: 12px;
    font-size: 24px;
    line-height: 36px;
    color: #777e90;
    text-align: center;
  }

  .btn-primary {
    width: 160px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    border-radius: 8px;
    background: #3772ff;
    cursor: pointer;
  }

  .btn-primary:hover {
    opacity: 0.9;
  }

  /* ---------- 首屏 ---------- */
  .section-banner {
    padding-top: 122px;
    padding-bottom: 70px;
    // 横向渐变：左蓝 → 右暖白
    background: linear-gradient(90deg, #e7f1ff 0%, #e7f6ff 50%, #fff8e9 100%);

    .banner-main {
      position: relative;
      width: 1280px;
      margin: 0 auto;
    }

    .banner-left {
      width: 680px;
      min-height: 328px;
    }

    .banner-pic {
      position: absolute;
      right: 0;
      top: -16px;
      width: 520px;
      height: 368px;
      flex-shrink: 0;
    }

    .banner-title {
      width: fit-content;
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      background: linear-gradient(
        90deg,
        #3772ff 0%,
        #aa56ff 35%,
        #ff6838 70%,
        #ff9924 100%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .banner-subtitle {
      margin-top: 13px;
      font-size: 40px;
      font-weight: 700;
      line-height: 66px;
      color: #1d1f24;
    }

    .banner-desc {
      margin-top: 9px;
      width: 584px;
      font-size: 20px;
      line-height: 29px;
      color: #6a7080;
    }

    .banner-btns {
      display: flex;
      margin-top: 33px;
    }

    .btn-ghost {
      margin-left: 36px;
      width: 160px;
      height: 48px;
      line-height: 46px;
      text-align: center;
      font-size: 18px;
      color: #3772ff;
      border: 1px solid #3772ff;
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .btn-ghost:hover {
      background: rgba(55, 114, 255, 0.08);
    }

    .banner-features-wrap {
      width: 1280px;
      margin: 0 auto;
    }

    .banner-features {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 80px;
      height: 120px;
      padding: 0 67px;
      background: rgba(255, 255, 255, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 20px;
      box-sizing: border-box;
      // 毛玻璃悬浮条：半透明白 + 背景模糊
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 24px rgba(23, 33, 94, 0.06);
    }

    .feature-item {
      display: flex;
      align-items: center;

      .feature-icon {
        width: 60px;
        height: 60px;
      }

      .feature-text {
        margin-left: 12px;

        .feature-title {
          font-size: 24px;
          font-weight: 700;
          line-height: 36px;
          color: #1d1f24;
        }

        .feature-sub {
          margin-top: 2px;
          font-size: 16px;
          line-height: 24px;
          color: #8a8f9e;
        }
      }
    }
  }

  /* ---------- 核心能力 ---------- */
  .section-adv {
    padding-top: 88px;
    padding-bottom: 96px;
    background: #ffffff;
    box-sizing: border-box;

    .adv-main {
      width: 1280px;
      margin: 0 auto;
    }

    .adv-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 64px;
    }

    .adv-card {
      width: 240px;
      min-height: 220px;
      padding: 33px 24px 0;
      background: #f7f9fe;
      border-radius: 12px;
      box-sizing: border-box;

      .adv-icon {
        width: 48px;
        height: 48px;
        display: block;
      }

      .adv-title {
        margin-top: 22px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .adv-desc {
        margin-top: 8px;
        font-size: 14px;
        line-height: 21px;
        color: #8a8f9e;
      }
    }
  }

  /* ---------- 工作原理 ---------- */
  .section-flow {
    padding-top: 88px;
    padding-bottom: 104px;
    background: #f7f9fe;
    box-sizing: border-box;

    .flow-main {
      width: 1280px;
      margin: 0 auto;
    }

    .flow-grid {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 64px;
    }

    .flow-card {
      // 340 宽卡 + 130 箭头间距，凑满 1280 内容区
      width: 340px;
      // 底部留白 14px：两行文案时内容 286，配合 min-height 300 全卡等高
      padding: 30px 20px 14px;
      // 卡片固定 300 高，文案行数不同也能等高
      min-height: 300px;
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 4px 30px 0 rgba(55, 114, 255, 0.05);
      box-sizing: border-box;

      .flow-top {
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 160px;
          height: 140px;
          object-fit: contain;
        }
      }

      .flow-title {
        margin-top: 26px;
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        color: #1d1f24;
        text-align: center;
      }

      .flow-desc {
        margin-top: 10px;
        font-size: 16px;
        line-height: 26px;
        color: #8a8f9e;
        text-align: center;
      }
    }

    .flow-arrow {
      // 相邻卡间距 130px，箭头 30x30 居中
      width: 130px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  /* ---------- 使用方式（深色区） ---------- */
  .section-usage {
    padding-top: 88px;
    padding-bottom: 104px;
    background: linear-gradient(180deg, #1d1f24 0%, #192238 100%);
    box-sizing: border-box;

    .usage-main {
      width: 1280px;
      margin: 0 auto;
    }

    .section-title {
      color: #ffffff;
    }

    .usage-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 64px;
    }

    .usage-card {
      width: 400px;
      padding-bottom: 36px;
      background: linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 100%);
      border-radius: 16px;
      box-sizing: border-box;

      .usage-top {
        height: 280px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 16px 16px 0 0;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .usage-title {
        margin-top: 22px;
        // 文本左右间距 30 / 24
        padding: 0 24px 0 30px;
        font-size: 30px;
        font-weight: 700;
        line-height: 42px;
        color: #ffffff;
        text-align: left;
      }

      .usage-desc {
        margin-top: 10px;
        // 左 30 右 24
        padding: 0 24px 0 30px;
        font-size: 16px;
        line-height: 26px;
        color: rgba(255, 255, 255, 0.55);
        text-align: left;
      }
    }
  }

  /* ---------- 应用场景 ---------- */
  .section-scene {
    padding-top: 88px;
    padding-bottom: 104px;
    background: #ffffff;
    box-sizing: border-box;

    .scene-main {
      width: 1280px;
      margin: 0 auto;
    }

    .scene-grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 64px;
    }

    .scene-card {
      // 4 卡布局：卡宽 302，间距 24
      width: 302px;
      margin-bottom: 24px;
      background: #ffffff;
      box-sizing: border-box;

      .scene-img-wrap {
        height: 180px;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          }
      }

      .scene-title {
        margin-top: 19px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .scene-desc {
        margin-top: 10px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 14px;
        line-height: 21px;
        color: #8a8f9e;
      }
    }
  }

  /* ---------- 底部 CTA ---------- */
  .section-cta {
    position: relative;
    padding-top: 62px;
    padding-bottom: 62px;
    background: #3772ff;
    overflow: hidden;
    box-sizing: border-box;

    .cta-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      mix-blend-mode: overlay;
      opacity: 0.6;
      pointer-events: none;
    }

    .cta-main {
      position: relative;
      width: 1280px;
      margin: 0 auto;
      text-align: center;
    }

    .cta-title {
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
      color: #ffffff;
    }

    .cta-sub {
      margin-top: 12px;
      font-size: 18px;
      color: #ffffff;
    }

    .cta-btn {
      margin: 28px auto 0;
      width: 168px;
      height: 48px;
      line-height: 48px;
      font-size: 19px;
      background: #ffffff;
      color: #3772ff;
    }
  }

  /* ---------- 滚动入场动画（同首页模式） ---------- */
  .move {
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  }
  .move-active {
    opacity: 1;
    transform: translateY(0);
  }
  /* 为不同元素设置不同的延迟，创建层次感 */
  .delay-100 {
    transition-delay: 0.1s;
  }
  .delay-200 {
    transition-delay: 0.2s;
  }
  .delay-300 {
    transition-delay: 0.3s;
  }
}
</style>
